/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type SubmitGooseGameOrganizerQuestLogMutationVariables = Types.Exact<{
  event_attendee_id: Types.Scalars["Float"];
  quest_id: Types.Scalars["Float"];
}>;

export type SubmitGooseGameOrganizerQuestLogMutation = {
  submitGooseGameOrganizerQuestLog: Pick<
    Types.GooseGameQuestLog,
    "id" | "quest_id" | "created_at"
  >;
};

export const SubmitGooseGameOrganizerQuestLogDocument = gql`
  mutation SubmitGooseGameOrganizerQuestLog(
    $event_attendee_id: Float!
    $quest_id: Float!
  ) {
    submitGooseGameOrganizerQuestLog(
      event_attendee_id: $event_attendee_id
      quest_id: $quest_id
    ) {
      id
      quest_id
      created_at
    }
  }
`;

/**
 * __useSubmitGooseGameOrganizerQuestLogMutation__
 *
 * To run a mutation, you first call `useSubmitGooseGameOrganizerQuestLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGooseGameOrganizerQuestLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGooseGameOrganizerQuestLogMutation, { data, loading, error }] = useSubmitGooseGameOrganizerQuestLogMutation({
 *   variables: {
 *      event_attendee_id: // value for 'event_attendee_id'
 *      quest_id: // value for 'quest_id'
 *   },
 * });
 */
export function useSubmitGooseGameOrganizerQuestLogMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SubmitGooseGameOrganizerQuestLogMutation,
    SubmitGooseGameOrganizerQuestLogMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    SubmitGooseGameOrganizerQuestLogMutation,
    SubmitGooseGameOrganizerQuestLogMutationVariables
  >(SubmitGooseGameOrganizerQuestLogDocument, baseOptions);
}
export type SubmitGooseGameOrganizerQuestLogMutationHookResult = ReturnType<
  typeof useSubmitGooseGameOrganizerQuestLogMutation
>;
export type SubmitGooseGameOrganizerQuestLogMutationResult =
  ApolloReactCommon.MutationResult<SubmitGooseGameOrganizerQuestLogMutation>;
export type SubmitGooseGameOrganizerQuestLogMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SubmitGooseGameOrganizerQuestLogMutation,
    SubmitGooseGameOrganizerQuestLogMutationVariables
  >;
